import { Component, OnInit } from '@angular/core';
import { RestaurantReviewsService } from '../../../services/restaurant-reviews/restaurant-reviews.service';
import { ReviewListResponse } from '../../../services/restaurant-reviews/model/review-list-response.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'web-foodis-section-reviews',
  templateUrl: './section-reviews.component.html',
  styleUrls: ['./section-reviews.component.scss'],
})
export class SectionReviewsComponent implements OnInit {

  public reviewsList$: Observable<ReviewListResponse[]> = this.reviewsService.getData$();

  public hoveredId: string | null = null;

  constructor(
    private reviewsService: RestaurantReviewsService
  ) {
    
  }

  public ngOnInit() {
    this.reviewsService.fetchAPI();
  }

}
